export default {
  CateCode: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
